import withStore from './withStore';
import withScreenCheck from './withScreenCheck';
import withPage from './withPage';

export {withStore, withScreenCheck, withPage};



// WEBPACK FOOTER //
// ./src/hoc/index.js